import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCaretDown,
  faExclamationTriangle,
  faBars
} from "@fortawesome/free-solid-svg-icons";

library.add(faCaretDown, faExclamationTriangle, faBars);
